import { Field, FieldArray, Form, Formik, getIn } from 'formik';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { forwardRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import * as Yup from 'yup';

const initialState = {
  addRates: [{ currency: '', cost: '' }],
};

const RatesFieldArray = ({ editRates }, ref) => {
  const [initialValues, setinitialValues] = useState(initialState);

  useEffect(() => {
    if (editRates && editRates.length > 0) {
      setinitialValues({ addRates: editRates });
    }
  }, [editRates]);

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      innerRef={ref}
      validateOnChange={true}
      validationSchema={Yup.object().shape({
        addRates: Yup.array().of(
          Yup.object().shape({
            currency: Yup.string().required('Required'),
            cost: Yup.number('amount cannot be empty'),
          }),
        ),
      })}
      render={({ values }) => (
        <Form>
          <FieldArray
            name="addRates"
            render={(arrayHelpers) => (
              <div>
                {values.addRates.map((rates, index) => (
                  <div className="d-flex align-items-baseline" key={index}>
                    <Row>
                      <Col>
                        <div className="form-group input_control">
                          <div className="w-100">
                            <Field
                              name={`addRates[${index}].currency`}
                              as="select"
                              className="form-control"
                              placeholder="Currency"
                            >
                              <option value="" key="0">
                                Select currency
                              </option>
                              <option value="EURO" key="1">
                                EURO
                              </option>
                              <option value="XOF" key="2">
                                XOF
                              </option>
                              <option value="USD" key="3">
                                USD
                              </option>
                              <option value="GBP" key="4">
                                GBP
                              </option>
                              <option value="NGN" key="5">
                                NGN
                              </option>
                            </Field>
                            <Field
                              name={`addRates[${index}].currency`}
                              render={({ form }) => {
                                const error = getIn(
                                  form.errors,
                                  `addRates[${index}].currency`,
                                );
                                const touch = getIn(
                                  form.touched,
                                  `addRates[${index}].currency`,
                                );
                                return touch && error ? (
                                  <div className="error_required">
                                    {' '}
                                    {error}{' '}
                                  </div>
                                ) : null;
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col>
                        <div className="form-group input_control input_control--gap">
                          <div className="w-100">
                            <Field
                              name={`addRates[${index}].cost`}
                              type="number"
                              step="any"
                              className="form-control"
                              placeholder="cost"
                            />
                            <Field
                              name={`addRates[${index}].cost`}
                              render={({ form }) => {
                                const error = getIn(
                                  form.errors,
                                  `addRates[${index}].cost`,
                                );
                                const touch = getIn(
                                  form.touched,
                                  `addRates[${index}].cost`,
                                );
                                return touch && error ? (
                                  <div className="error_required">
                                    {' '}
                                    {error}{' '}
                                  </div>
                                ) : null;
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <div className="d-flex ">
                      <button
                        className="btn btn-dark-blue mr-1"
                        type="button"
                        onClick={() =>
                          arrayHelpers.push({
                            currency: '',
                            cost: '',
                          })
                        }
                      >
                        Add
                      </button>
                      {values.addRates.length !== 1 && (
                        <button
                          className="btn btn-danger"
                          type="button"
                          onClick={() => arrayHelpers.remove(index)}
                        >
                          Remove
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          />
        </Form>
      )}
    />
  );
};

export default forwardRef(RatesFieldArray);
